<template>
  <v-app>
    <v-container>
      <v-row justify="center">
        <!-- Navigation Bar -->
        <v-col cols="12" class="mb-8">
          <NavBar :pageTitle="pageTitle" />
        </v-col>
        <v-col cols="12" class="flex-box">
          <v-card outlined class="text-pure-white bg-aqua-teal">
            <v-card-title class="text-center text-wrap">{{ pageTitle }}</v-card-title>
            <v-card-text>
              {{ pageDescription }}
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <div class="flex-box">
            <ToggleButton v-model="contentType.choiceNumber"
                          :value-string="contentType.choiceName"
                          @update:valueString="newValue => contentType.choiceName = newValue" />
          </div>
        </v-col>
        <v-divider class="border-opacity-25"></v-divider>
        <v-col cols="12">
          <div class="flex-box">
            <ListContent :items="getFilteredContent"/>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- Footer -->
    <MENDFooter />
  </v-app>
</template>

<script>
import ListContent from './ListContent.vue';
import MENDFooter from './MENDFooter.vue';
import NavBar from './NavBar.vue';
import ToggleButton from './ToggleButton.vue';
import axios from 'axios';

export default {
  name: 'SubPage',
  components: {
    ListContent,
    MENDFooter,
    NavBar,
    ToggleButton,
  },
  props: ['subpageid'],
  watch: {
    // If pageid is changed, retrieve relevant content.
    subpageid(){
      this.fetchData();
    }
  },
  data() {
    return {
      contentType: {
        choiceNumber: 0,
        choiceName: 'Video',
      },
      subpage: [],
      activePanel: null, // Added for v-expansion-panels binding
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (this.subpageid === "#") {
          this.subpage = [];
          return;
      }
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        const response = await axios.get(`/api/subpage/${this.subpageid}`);
        this.subpage = response.data;
      } catch (error) {
        console.log(error);
        this.subpage = [];
      }
    },
    listHasEntry(){
      return this.subpage.length > 0;
    }
  },
  computed: {
    getContent() {
      if (!this.listHasEntry) return [];
      return this.subpage.subpagecontents;
    },
    pageDescription() {
      if (!this.listHasEntry) return 'No content available';
      return this.subpage.subPageDescription;
    },
    pageTitle() {
      if (!this.listHasEntry) return '';
      return this.subpage.subPageTitle;
    },
    getFilteredContent() {
      if (!this.listHasEntry) return [];
      const content = this.subpage.subpagecontents || [];
      const filteredContent = [];
      for (let i = 0; i < content.length; i++) {
        if (content[i].contentBlock === this.contentType.choiceName) {
          content[i]['contentId'] = content[i].subpageid;
          filteredContent.push(content[i]);
        }
      }
      return filteredContent;
    },
  },
};
</script>

<style>
* {
  font-family: 'Montserrat';
}

.flex-box {
  display: flex;
  justify-content: center;
}

.text-pure-white {
  color: #FFFFFF;
}

.bg-aqua-teal {
  background-color: #08B6AA;
}
</style>
